import { Box, makeStyles } from '@material-ui/core';
import React from 'react'
import { Player, BigPlayButton } from 'video-react';

interface Props{
  videoSrc: string
  thumbnail?: string
}

const useStyles = makeStyles(({typography})=>({
  root: {
    '& .video-react-poster': {
      backgroundSize: 'cover !important'
    },
    '& .video-react-control-bar': {
      ...typography.caption
    }
  }
}))

export const IntroVideo: React.FC<Props> = ({videoSrc, thumbnail}) => {
  const classes = useStyles()
  return (
    <Box className={classes.root} mb={2}>
      <Player poster={thumbnail} src={videoSrc} >
        <BigPlayButton position="center" />
      </Player>
    </Box>
  );
};